import { AreaExtra, Connection, LORa, LTE, MotherBoard, SAT, Schemes } from "@/rete/default";
import { NodeEditor } from "rete";
import { AreaPlugin } from "rete-area-plugin";

export type GraphSpec = {
	nodes: {
		alias: string;
		type: "MotherBoard" | "SAT" | "LORa" | "LTE/5G";
		position?: { x: number; y: number };
	}[];
	connections: { from: string; to: string; out?: string; in?: string }[];
};

export async function applyGraphSpec(editor: NodeEditor<Schemes>, area: AreaPlugin<Schemes, AreaExtra>, spec: GraphSpec) {
	const alias = new Map<string, any>();

	for (const n of spec.nodes) {
		const node = n.type === "MotherBoard" ? new MotherBoard() : n.type === "SAT" ? new SAT() : n.type === "LORa" ? new LORa() : new LTE();

		await editor.addNode(node); // <-- AWAIT
		alias.set(n.alias, node);

		if (n.position) {
			const view = area.nodeViews.get(node.id);
			view?.translate(n.position.x, n.position.y);
		}
	}

	for (const c of spec.connections) {
		const src = alias.get(c.from);
		const dst = alias.get(c.to);
		if (src && dst) {
			await editor.addConnection(
				// <-- AWAIT
				new Connection(src, c.out ?? "value", dst, c.in ?? "value")
			);
		}
	}
}
